export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/bass.be5aebb.svg";